<ng-container>

  <div>
    <b>{{ name }}</b>
    <app-info class="formGroupLabel" [wide]="false" [placement]="'left'">
      <div class="tooltipContent">
        <b>Considering</b>
        <ul>
          @for (consider of splitConsidering(); track consider) {
            <div>
              <li>
                {{ consider }}
              </li>
            </div>
          }
        </ul>
      </div>
    </app-info>
  </div>


  <ng-container>
    <div class="row">
      <div class="col-md fieldset">
        <app-visit-exemptions-exemption-common [exemption]="exemption"></app-visit-exemptions-exemption-common>
        <div class="col-md">
          <app-form-group label="Vessel type">
            <app-select [(ngModel)]="exemption.vesselType" (ngModelChange)="resetVesselInfo()" id="vesselType"
                        [options]="vesselTypes"
                        [formatter]="vesselTypesFormatter" required>
            </app-select>
          </app-form-group>
          @if (exemption.vesselType === 'IMO') {
            <app-form-group>
              <app-info class="formGroupLabel">
                <label>Vessel name/IMO number</label>
                <div class="tooltipContent">Name of vessel receiving cargo being pumped over</div>
              </app-info>
              <app-search [(ngModel)]="vessel" (ngModelChange)="onVesselChange(vessel)" [searchFunction]="searchVessel"
                          [inputFormatter]="vesselNameFormatter"
                          [minCharacters]="3" dataKey="imoCode" id="vessel">
              </app-search>
            </app-form-group>
          }
        </div>
        <div class="col-md">
          @if (exemption.vesselType === 'IMO') {
            <app-form-group label="Name">
              <input [(ngModel)]="exemption.vesselNameIMO" id="vesselName" type="text" maxlength="64"
                     class="form-control" readonly required>
            </app-form-group>
          }
          @if (exemption.vesselType === 'IMO') {
            <app-form-group label="IMO number">
              <input [(ngModel)]="exemption.vesselIMO" id="vesselIMO" type="text" maxlength="64"
                     class="form-control" readonly required>
            </app-form-group>
          }
          @if (exemption.vesselType === 'ENI') {
            <app-form-group label="Name">
              <input [(ngModel)]="exemption.vesselNameENI" id="vesselNameENI" type="text" maxlength="64"
                     class="form-control" required>
            </app-form-group>
          }
          @if (exemption.vesselType === 'ENI') {
            <app-form-group label="ENI number">
              <input [(ngModel)]="exemption.vesselENI" id="vesselENI" type="text" maxlength="64"
                     class="form-control" required>
            </app-form-group>
          }
        </div>

        <div class="row">
          <app-form-group label="Name of vessel owner or charterer">
            <input [(ngModel)]="exemption.vesselOwnerName" type="text" class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Name of company receiving fuel to be debunkered">
            <input [(ngModel)]="exemption.receivingCompanyName" type="text" class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Name of contact">
            <input [(ngModel)]="exemption.contactName" type="text" class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Telephone number">
            <input [(ngModel)]="exemption.contactTelephone" type="text" class="form-control"
                   required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Email">
            <input [(ngModel)]="exemption.contactEmailAddress" type="text" class="form-control" required>
          </app-form-group>
        </div>
      </div>

      <div class="col-md fieldset">
        <div class="row">
          <app-form-group label="Start of debunkering">
            <app-date-field [(ngModel)]="exemption.startTime"></app-date-field>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="End of debunkering">
            <app-date-field [(ngModel)]="exemption.endTime"></app-date-field>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Fuel Grade">
            <input [(ngModel)]="exemption.fuelGrade" type="text" class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Product">
            <app-search [(ngModel)]="exemption.bunkerItem.product"
                        [searchFunction]="products"
                        [resultFormatter]="formatProduct"
                        [inputFormatter]="formatProduct"
                        required placeholder="Product type"></app-search>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Quantity">
            <div class="input-group">
              <input type="number" appDecimalNumber [maxDecimals]="0" [min]="0"
                     [(ngModel)]="exemption.bunkerItem.quantity"
                     class="form-control" required>
              @if (!!exemption.bunkerItem.product) {
                <span class="input-group-text">
                  {{ exemption.bunkerItem.product?.unitOfMeasure }}
                </span>
              }
            </div>
          </app-form-group>
        </div>

        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Origin of fuel to be de-bunkered</label>
              <span class="tooltipContent">Such as city, country, terminal, supplier</span>
            </app-info>
            <input [(ngModel)]="exemption.fuelOrigin" type="text" class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Destination of fuel to be debunkered">
            <app-search [(ngModel)]="exemption.fuelDestination" [required] [searchFunction]="searchDestinations"
                        placeholder="Select one of the options or type a new one"
                        [newValueFromInputFunction]="newDestination" [minCharacters]="0"></app-search>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Name and address</label>
              <span class="tooltipContent">Contact and destination address of de-bunkered fuel</span>
            </app-info>
            <textarea [(ngModel)]="exemption.destinationNameAndAddress" class="form-control" [rows]="3"></textarea>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Reason for debunkering">
            <app-search [(ngModel)]="exemption.reason" [required] [searchFunction]="searchReasons"
                        placeholder="Select one of the options or type a new one"
                        [newValueFromInputFunction]="newReason" [minCharacters]="0"></app-search>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Details">
            <textarea [(ngModel)]="exemption.details" type="text" rows="3" maxlength="256"
                      class="form-control"></textarea>
          </app-form-group>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
